// extracted by mini-css-extract-plugin
export default {"box":"ModalPortal_box__GsFFN","dimmer-box":"ModalPortal_dimmer-box__2UFzR","dissolve":"ModalPortal_dissolve__MyGJ-"};